import '../Sass/App.scss';
import * as React from 'react';
import { TopBar } from './TopBar';
import { Home } from './Home';
import { Docs } from './Docs2';
import { Gameboard } from './Gameboard2';
import { Shop } from './Shop';
import { ShoppingCart } from './ShoppingCart';
import { Rules } from './Rules';
import { DevGuide } from './DevGuide';

export class Main extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 'malware',
            playtestCounter: 0,
            sendId: 0,
            cartOpen: false,
            profileCommand: null,
            resetToken: null
        };
        this.changePage = this.changePage.bind(this);
        this.resetPlaytest = this.resetPlaytest.bind(this);
        this.openCart = this.openCart.bind(this);
        this.closeCart = this.closeCart.bind(this);
        this.openProfile = this.openProfile.bind(this);
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const resetToken = params.get('reset_token');

        if (resetToken) {
            this.setState({
                profileCommand: {
                    mode: 'reset-password',
                    issuedAt: Date.now()
                },
                resetToken: resetToken
            });
        }
    }

    changePage(newPage, sendId) {
        this.setState({
            currentPage: newPage,
            sendId: sendId
        })
    }

    resetPlaytest() {
        var newCounter = this.state.playtestCounter + 1;
        this.setState({
            playtestCounter: newCounter
        })
    }

    openCart() {
        this.setState({
            cartOpen: true
        })
    }

    closeCart() {
        this.setState({
            cartOpen: false
        })
    }

    openProfile(mode = 'login') {
        this.setState({
            profileCommand: {
                mode: mode,
                issuedAt: Date.now()
            }
        })
    }


    render() {
        return (
            <div>
                <TopBar appName={this.state.currentPage} changePage={this.changePage} resetPlaytest={this.resetPlaytest} openCart={this.openCart} profileCommand={this.state.profileCommand} resetToken={this.state.resetToken} />
                { this.state.currentPage === 'malware' && 
                    <Home changePage={this.changePage} />
                }
                { this.state.currentPage === 'documentation' &&
                    <Docs key={this.state.sendId} changePage={this.changePage} codebaseId={this.state.sendId} />
                }
                { this.state.currentPage === 'playtest engine' &&
                    <Gameboard key={this.state.playtestCounter} codebaseId={this.state.sendId} />
                }
                { this.state.currentPage === 'shop' &&
                    <Shop key={this.state.sendId || 'shop'} changePage={this.changePage} initialShop={this.state.sendId} />
                }
                { this.state.currentPage === 'rules' &&
                    <Rules changePage={this.changePage} />
                }
                { this.state.currentPage === 'devguide' &&
                    <DevGuide changePage={this.changePage} />
                }
                <ShoppingCart open={this.state.cartOpen} onClose={this.closeCart} openProfile={this.openProfile} />
            </div>
        )
    }
}
